<template>
  <v-list-tile :to="realTo" :class="{'non-clickable': !clickable}">
    <v-list-tile-avatar>
      <h-icon>{{icon}}</h-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>{{name}}</v-list-tile-content>
    <v-list-tile-avatar v-if="tutorial">
      <h-icon @click="displayTutorial">help</h-icon>
    </v-list-tile-avatar>
  </v-list-tile>
</template>

<script>
import AuthUser from "@/services/api/authUser";
export default {
  props: ["icon", "to", "name", "routeName", "tutorial"],
  data() {
    return {
      realTo: {},
      AuthUser
    };
  },
  created() {
    this.realTo = this.to || { name: this.routeName };
  },
  methods: {
    displayTutorial() {
      this.$eventHub.$emit("youtubeTutorial", this.tutorial);
    }
  },
  computed: {
    clickable() {
      return AuthUser.hasPermission(this.routeName);
    },
  }
};
</script>
